import { PageHeader } from '@/components/PageHeader';
import { UsersTable } from './UsersTable';
import { CreateUserModal } from './CreateUserModal';
import { usePageTitle } from '@/hooks';

export const UsersPage = () => {
  usePageTitle('Users');
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader>
        <h1 className="text-3xl font-bold">Users</h1>
        <CreateUserModal />
      </PageHeader>
      <UsersTable />
    </div>
  );
};
